export default __webpack_public_path__ + "static/media/(44).9682f9cd.jpg";